// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================================================
   TOOLBAR
   ================================================== */

.text-toolbar {

    height: 18px;

    display: flex;
    align-items: center;

    background: transparent;

    -webkit-user-select: none;

            user-select: none;

    box-sizing: border-box;
}


/* ==================================================
   COULEURS
   ================================================== */

.toolbar-colors {

    height: 18px;

    display: flex;
    align-items: center;

    gap: 3px;
}


/* ==================================================
   BOUTON COULEUR
   ================================================== */

.color-button {

    width: 18px;
    height: 18px;

    padding: 0;
    margin: 0;

    border: none;

    background: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    border-radius: 50%;

    transition:
        transform 0.08s ease;
}


/* ==================================================
   CERCLE DE COULEUR
   ================================================== */

.color-button span {

    width: 14px;
    height: 14px;

    display: block;

    border-radius: 50%;

    background: var(--button-color);

    box-shadow:
        inset 0 1px 2px rgba(255, 255, 255, 0.35),
        inset 0 -1px 2px rgba(0, 0, 0, 0.35);

    transition:
        width 0.08s ease,
        height 0.08s ease,
        box-shadow 0.08s ease;
}


/* ==================================================
   COULEUR : SURVOL
   ================================================== */

.color-button:hover span {

    width: 16px;
    height: 16px;

    box-shadow:
        inset 0 1px 2px rgba(255, 255, 255, 0.45),
        inset 0 -1px 2px rgba(0, 0, 0, 0.4),
        0 0 2px rgba(255, 255, 255, 0.5);
}


/* ==================================================
   COULEUR : SÉLECTIONNÉE
   ================================================== */

.color-button.selected span {

    width: 15px;
    height: 15px;

    box-shadow:
        0 0 0 1px rgba(255, 255, 255, 0.8),
        0 0 0 2px rgba(0, 0, 0, 0.45);
}


/* ==================================================
   COULEUR : CLIC
   ================================================== */

.color-button:active {

    transform: scale(0.80);
}


/* ==================================================
   ZONE ALIGNEMENTS
   ================================================== */

.toolbar-align {

    height: 18px;

    margin-left: 4px;
    padding-left: 4px;

    display: flex;
    align-items: center;

    

    box-sizing: border-box;
}


/* ==================================================
   BOUTON ALIGNEMENT
   ================================================== */

.align-button {

    position: relative;

    width: 21px;
    height: 18px;

    padding: 0;
    margin: 0;

    border: none;

    background: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    border-radius: 2px;

    transition:
        background 0.08s ease,
        transform 0.08s ease;
}


/* ==================================================
   ICÔNE ALIGNEMENT
   ================================================== */

.align-icon {

    width: 15px;
    height: 12px;

    display: flex;

    flex-direction: column;

    justify-content: space-between;

    box-sizing: border-box;
}


/* ==================================================
   TRAITS
   ================================================== */

.align-icon i {

    display: block;

    height: 1.5px;

    border-radius: 2px;

    background: #bfc7df;

    flex-shrink: 0;

    transition:
        width 0.08s ease,
        background 0.08s ease,
        transform 0.08s ease;
}


/* ==================================================
   ALIGNEMENT GAUCHE
   Tous les traits commencent à gauche
   ================================================== */

.align-left {

    align-items: flex-start;
}


.align-left i:nth-child(1) {
    width: 15px;
}


.align-left i:nth-child(2) {
    width: 11px;
}


.align-left i:nth-child(3) {
    width: 14px;
}


.align-left i:nth-child(4) {
    width: 9px;
}


/* ==================================================
   ALIGNEMENT CENTRE
   Tous les traits sont centrés
   ================================================== */

.align-center {

    align-items: center;
}


.align-center i:nth-child(1) {
    width: 11px;
}


.align-center i:nth-child(2) {
    width: 15px;
}


.align-center i:nth-child(3) {
    width: 9px;
}


.align-center i:nth-child(4) {
    width: 13px;
}


/* ==================================================
   ALIGNEMENT DROITE
   Tous les traits terminent à droite
   ================================================== */

.align-right {

    align-items: flex-end;
}


.align-right i:nth-child(1) {
    width: 15px;
}


.align-right i:nth-child(2) {
    width: 11px;
}


.align-right i:nth-child(3) {
    width: 14px;
}


.align-right i:nth-child(4) {
    width: 9px;
}


/* ==================================================
   ALIGNEMENT : SURVOL
   ================================================== */

.align-button:hover {

    background: rgba(255, 255, 255, 0.13);

    box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.10);
}


.align-button:hover .align-icon i {

    background: #ffffff;
}


/* ==================================================
   ALIGNEMENT : SÉLECTIONNÉ
   ================================================== */

.align-button.selected {

    background: rgba(255, 255, 255, 0.20);

    box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.25);
}


.align-button.selected .align-icon i {

    background: #ffffff;
}


/* ==================================================
   ALIGNEMENT : CLIC
   ================================================== */

.align-button:active {

    transform: scale(0.88);
}


.align-button:active .align-icon {

    transform: scale(0.90);
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitles/list-st/components/subtitle/texttoolbar.css"],"names":[],"mappings":"AAAA;;uDAEuD;;AAEvD;;IAEI,YAAY;;IAEZ,aAAa;IACb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,yBAAiB;;YAAjB,iBAAiB;;IAEjB,sBAAsB;AAC1B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,YAAY;;IAEZ,aAAa;IACb,mBAAmB;;IAEnB,QAAQ;AACZ;;;AAGA;;uDAEuD;;AAEvD;;IAEI,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,SAAS;;IAET,YAAY;;IAEZ,uBAAuB;;IAEvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;;IAEf,kBAAkB;;IAElB;4BACwB;AAC5B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,WAAW;IACX,YAAY;;IAEZ,cAAc;;IAEd,kBAAkB;;IAElB,+BAA+B;;IAE/B;;4CAEwC;;IAExC;;;6BAGyB;AAC7B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,WAAW;IACX,YAAY;;IAEZ;;;wCAGoC;AACxC;;;AAGA;;uDAEuD;;AAEvD;;IAEI,WAAW;IACX,YAAY;;IAEZ;;qCAEiC;AACrC;;;AAGA;;uDAEuD;;AAEvD;;IAEI,sBAAsB;AAC1B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,YAAY;;IAEZ,gBAAgB;IAChB,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;;;;IAInB,sBAAsB;AAC1B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,SAAS;;IAET,YAAY;;IAEZ,uBAAuB;;IAEvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;;IAEf,kBAAkB;;IAElB;;4BAEwB;AAC5B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,WAAW;IACX,YAAY;;IAEZ,aAAa;;IAEb,sBAAsB;;IAEtB,8BAA8B;;IAE9B,sBAAsB;AAC1B;;;AAGA;;uDAEuD;;AAEvD;;IAEI,cAAc;;IAEd,aAAa;;IAEb,kBAAkB;;IAElB,mBAAmB;;IAEnB,cAAc;;IAEd;;;4BAGwB;AAC5B;;;AAGA;;;uDAGuD;;AAEvD;;IAEI,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,UAAU;AACd;;;AAGA;;;uDAGuD;;AAEvD;;IAEI,mBAAmB;AACvB;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,UAAU;AACd;;;AAGA;IACI,WAAW;AACf;;;AAGA;;;uDAGuD;;AAEvD;;IAEI,qBAAqB;AACzB;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,UAAU;AACd;;;AAGA;;uDAEuD;;AAEvD;;IAEI,qCAAqC;;IAErC;iDAC6C;AACjD;;;AAGA;;IAEI,mBAAmB;AACvB;;;AAGA;;uDAEuD;;AAEvD;;IAEI,qCAAqC;;IAErC;iDAC6C;AACjD;;;AAGA;;IAEI,mBAAmB;AACvB;;;AAGA;;uDAEuD;;AAEvD;;IAEI,sBAAsB;AAC1B;;;AAGA;;IAEI,sBAAsB;AAC1B","sourcesContent":["/* ==================================================\n   TOOLBAR\n   ================================================== */\n\n.text-toolbar {\n\n    height: 18px;\n\n    display: flex;\n    align-items: center;\n\n    background: transparent;\n\n    user-select: none;\n\n    box-sizing: border-box;\n}\n\n\n/* ==================================================\n   COULEURS\n   ================================================== */\n\n.toolbar-colors {\n\n    height: 18px;\n\n    display: flex;\n    align-items: center;\n\n    gap: 3px;\n}\n\n\n/* ==================================================\n   BOUTON COULEUR\n   ================================================== */\n\n.color-button {\n\n    width: 18px;\n    height: 18px;\n\n    padding: 0;\n    margin: 0;\n\n    border: none;\n\n    background: transparent;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    cursor: pointer;\n\n    border-radius: 50%;\n\n    transition:\n        transform 0.08s ease;\n}\n\n\n/* ==================================================\n   CERCLE DE COULEUR\n   ================================================== */\n\n.color-button span {\n\n    width: 14px;\n    height: 14px;\n\n    display: block;\n\n    border-radius: 50%;\n\n    background: var(--button-color);\n\n    box-shadow:\n        inset 0 1px 2px rgba(255, 255, 255, 0.35),\n        inset 0 -1px 2px rgba(0, 0, 0, 0.35);\n\n    transition:\n        width 0.08s ease,\n        height 0.08s ease,\n        box-shadow 0.08s ease;\n}\n\n\n/* ==================================================\n   COULEUR : SURVOL\n   ================================================== */\n\n.color-button:hover span {\n\n    width: 16px;\n    height: 16px;\n\n    box-shadow:\n        inset 0 1px 2px rgba(255, 255, 255, 0.45),\n        inset 0 -1px 2px rgba(0, 0, 0, 0.4),\n        0 0 2px rgba(255, 255, 255, 0.5);\n}\n\n\n/* ==================================================\n   COULEUR : SÉLECTIONNÉE\n   ================================================== */\n\n.color-button.selected span {\n\n    width: 15px;\n    height: 15px;\n\n    box-shadow:\n        0 0 0 1px rgba(255, 255, 255, 0.8),\n        0 0 0 2px rgba(0, 0, 0, 0.45);\n}\n\n\n/* ==================================================\n   COULEUR : CLIC\n   ================================================== */\n\n.color-button:active {\n\n    transform: scale(0.80);\n}\n\n\n/* ==================================================\n   ZONE ALIGNEMENTS\n   ================================================== */\n\n.toolbar-align {\n\n    height: 18px;\n\n    margin-left: 4px;\n    padding-left: 4px;\n\n    display: flex;\n    align-items: center;\n\n    \n\n    box-sizing: border-box;\n}\n\n\n/* ==================================================\n   BOUTON ALIGNEMENT\n   ================================================== */\n\n.align-button {\n\n    position: relative;\n\n    width: 21px;\n    height: 18px;\n\n    padding: 0;\n    margin: 0;\n\n    border: none;\n\n    background: transparent;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    cursor: pointer;\n\n    border-radius: 2px;\n\n    transition:\n        background 0.08s ease,\n        transform 0.08s ease;\n}\n\n\n/* ==================================================\n   ICÔNE ALIGNEMENT\n   ================================================== */\n\n.align-icon {\n\n    width: 15px;\n    height: 12px;\n\n    display: flex;\n\n    flex-direction: column;\n\n    justify-content: space-between;\n\n    box-sizing: border-box;\n}\n\n\n/* ==================================================\n   TRAITS\n   ================================================== */\n\n.align-icon i {\n\n    display: block;\n\n    height: 1.5px;\n\n    border-radius: 2px;\n\n    background: #bfc7df;\n\n    flex-shrink: 0;\n\n    transition:\n        width 0.08s ease,\n        background 0.08s ease,\n        transform 0.08s ease;\n}\n\n\n/* ==================================================\n   ALIGNEMENT GAUCHE\n   Tous les traits commencent à gauche\n   ================================================== */\n\n.align-left {\n\n    align-items: flex-start;\n}\n\n\n.align-left i:nth-child(1) {\n    width: 15px;\n}\n\n\n.align-left i:nth-child(2) {\n    width: 11px;\n}\n\n\n.align-left i:nth-child(3) {\n    width: 14px;\n}\n\n\n.align-left i:nth-child(4) {\n    width: 9px;\n}\n\n\n/* ==================================================\n   ALIGNEMENT CENTRE\n   Tous les traits sont centrés\n   ================================================== */\n\n.align-center {\n\n    align-items: center;\n}\n\n\n.align-center i:nth-child(1) {\n    width: 11px;\n}\n\n\n.align-center i:nth-child(2) {\n    width: 15px;\n}\n\n\n.align-center i:nth-child(3) {\n    width: 9px;\n}\n\n\n.align-center i:nth-child(4) {\n    width: 13px;\n}\n\n\n/* ==================================================\n   ALIGNEMENT DROITE\n   Tous les traits terminent à droite\n   ================================================== */\n\n.align-right {\n\n    align-items: flex-end;\n}\n\n\n.align-right i:nth-child(1) {\n    width: 15px;\n}\n\n\n.align-right i:nth-child(2) {\n    width: 11px;\n}\n\n\n.align-right i:nth-child(3) {\n    width: 14px;\n}\n\n\n.align-right i:nth-child(4) {\n    width: 9px;\n}\n\n\n/* ==================================================\n   ALIGNEMENT : SURVOL\n   ================================================== */\n\n.align-button:hover {\n\n    background: rgba(255, 255, 255, 0.13);\n\n    box-shadow:\n        inset 0 0 0 1px rgba(255, 255, 255, 0.10);\n}\n\n\n.align-button:hover .align-icon i {\n\n    background: #ffffff;\n}\n\n\n/* ==================================================\n   ALIGNEMENT : SÉLECTIONNÉ\n   ================================================== */\n\n.align-button.selected {\n\n    background: rgba(255, 255, 255, 0.20);\n\n    box-shadow:\n        inset 0 0 0 1px rgba(255, 255, 255, 0.25);\n}\n\n\n.align-button.selected .align-icon i {\n\n    background: #ffffff;\n}\n\n\n/* ==================================================\n   ALIGNEMENT : CLIC\n   ================================================== */\n\n.align-button:active {\n\n    transform: scale(0.88);\n}\n\n\n.align-button:active .align-icon {\n\n    transform: scale(0.90);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
